import React, { useRef, useState, useEffect } from 'react';

import components from "../components"
import Fallback from "../fallback"
import { generateBackground } from '../utils/utils'

import { AnimatePresence, motion, useInView } from "framer-motion"

import {
  Accordion,
  Grid,
  Icon,
  //Image,
} from 'semantic-ui-react';

export default function ContentAccordionImage(props) {
  //console.log('ContentAccordionImage - props', props);

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;

  const {
    accordionPanels
  } = props;

  const [sectionBackgrounds, setSectionBackgrounds] = useState(null);

  //generate section backgrounds
  useEffect(() => {
    if (!sectionBackgrounds && (accordionPanels && accordionPanels.contentItems && accordionPanels.contentItems.length !== 0)) {
      let generatedBackgroundsArray = [];
      for (const contentItem of accordionPanels.contentItems) {
        //console.debug('contentItem', contentItem);
        const generatedBackground = generateBackground('white', contentItem.contentImage);
        generatedBackgroundsArray = [...generatedBackgroundsArray, generatedBackground]
      }
      setSectionBackgrounds(generatedBackgroundsArray)
    }
  }, [sectionBackgrounds,accordionPanels]);

  const [activeIndex, setActiveIndex] = useState(0);
  const [autoplayState, setAutoplayState] = useState(true);

  const handleClick = (e, titleProps) => {
    if (autoplayState === true) {
      setAutoplayState(false);
    }
    const { index } = titleProps;
    if (index !== activeIndex) {
      const newIndex = activeIndex === index ? -1 : index;
      setActiveIndex(newIndex);
    }
  }

  //let activePanel = accordionPanels.contentItems[activeIndex];
  //console.debug('ContentAccordionImage - activePanel', activePanel);


  //const accordionContentBackground = generateBackground('white', activePanel.contentImage);
  //console.debug('ContentAccordionImage - accordionContentBackground', accordionContentBackground);

  useEffect(() => {
    let interval
    if (autoplayState === true) {
      interval = setInterval(() => {
        //console.debug('This will be called every 2 seconds');
        const newIndex = (activeIndex + 1) < accordionPanels.contentItems.length ? (activeIndex + 1) : 0;
        //console.debug('newIndex', newIndex);
        setActiveIndex(newIndex);
      }, 4000);
    
      return () => clearInterval(interval);
    } else {
      return () => clearInterval(interval);
    }
  }, [autoplayState,activeIndex,accordionPanels]);

  const targetElementRef = useRef(null)

  const isInView = useInView(targetElementRef,{
    margin: "0px 0px 00px 0px"
  })

  useEffect(() => {
    //console.log("Element is in view: ", isInView)
    if (!isInView) {
      setAutoplayState(false);
    } else {
      setAutoplayState(true);
    }
  }, [isInView])

  //console.debug('targetElementRef', targetElementRef);
  //console.debug('isInView', isInView);
  //console.debug('sectionBackgrounds', sectionBackgrounds);
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <Grid stretched stackable className={'site-content-accordion-image'}>
        <Grid.Row>
          <Grid.Column width={6}>
            <Accordion>
              {accordionPanels && accordionPanels.contentItems.length !== 0 && accordionPanels.contentItems.map((panel, i) => {
                return (
                  <div key={i} className={panel.key}
                    style={{ background: (panel.commonPageSection.backgroundColor ? panel.commonPageSection.backgroundColor : null), color: (panel.commonPageSection.textColor ? panel.commonPageSection.textColor : null), }}
                    ref={i===0 ? targetElementRef : null}
                  >
                    <Accordion.Title
                      active={activeIndex === i}
                      index={i}
                      onClick={handleClick}
                    >
                      <div>
                        <div>
                          <Icon circular size={'small'} name={panel.icon.iconName} />
                        </div>
                        
                        {/* <Image size={'small'} src={} /> */}
                        <span>{panel.headline}</span>
                      </div>
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === i}>
                      <AnimatePresence mode={'sync'}>
                        {activeIndex === i ?
                          <motion.div key={i}
                            initial={{
                              //height: 0,
                              opacity: 0,
                            }}
                            animate={{
                              //height: "auto",
                              opacity: 1,
                              transition: {
                                // height: {
                                //   duration: 0.4,
                                //   delay: 0.15,
                                // },
                                opacity: {
                                  duration: 0.25,
                                  delay: 0.15,
                                },
                              },
                            }}
                            exit={{
                              //height: 0,
                              opacity: 0,
                            }}
                          >
                            {panel.contentCollection && panel.contentCollection.contentItems.length !== 0 && panel.contentCollection.contentItems.map((block,i) => {
                              //console.debug('block', block)
                              const { contentType } = block
                              //console.debug('components[blocktype]', components[blocktype.metaname])
                              const Component = components[contentType] || Fallback
                              return <Component key={i} renderSource={panel.contentType} {...block} />
                            })}
                          </motion.div>
                        :
                          null
                        }
                      </AnimatePresence>
                    </Accordion.Content>
                  </div>
                )
              })}
            </Accordion>
          </Grid.Column>
          <Grid.Column width={10} 
            style={{ background: sectionBackgrounds ? sectionBackgrounds[activeIndex] : null, }}
            //style={{ background: (accordionPanels.contentItems[activeIndex].contentImage.imageAbsoluteUrls[0] ? 'url('+accordionPanels.contentItems[activeIndex].contentImage.imageAbsoluteUrls[0]+') top center no-repeat' : null), }}
          >
            {/* {props.panels && props.panels.length !== 0 && props.panels.map((panel, i) => 
              <Image key={i} fluid src={panel.image} style={{ display: (activeIndex === i ? 'block' : 'none')}} />
            )} */}
          </Grid.Column>
        </Grid.Row>
      </Grid>
      
    </>
  )
}
